import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Apple24 = ({
  height = 24,
  width = 24,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 24 24"
    data-test="icon-apple"
    {...props}
  >
    <path
      d="M14.6224 6.1952C15.2832 5.42484 15.6702 4.46498 15.7252 3.46039C15.7279 3.39329 15.7151 3.32644 15.6875 3.26493C15.66 3.20342 15.6185 3.14884 15.5663 3.10535C15.514 3.06185 15.4523 3.03057 15.3859 3.01388C15.3194 2.99719 15.25 2.99553 15.1828 3.00901C14.1994 3.23017 13.3112 3.74698 12.6428 4.48705C11.9787 5.22672 11.5817 6.15973 11.5128 7.1422C11.5112 7.20497 11.5233 7.26736 11.5482 7.32522C11.5731 7.38308 11.6103 7.43508 11.6574 7.47778C11.7044 7.52047 11.7601 7.55288 11.8209 7.57284C11.8817 7.59281 11.9462 7.59988 12.01 7.59358C13.0305 7.46915 13.9645 6.9692 14.6224 6.1952Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M16.9053 12.7129C16.9047 12.1028 17.0453 11.5011 17.3158 10.9557C17.5863 10.4104 17.9794 9.93654 18.4634 9.57204C18.5062 9.53816 18.5417 9.49588 18.5678 9.44775C18.5939 9.39962 18.61 9.34664 18.6153 9.29202C18.6205 9.2374 18.6148 9.18226 18.5983 9.12995C18.5819 9.07765 18.5551 9.02925 18.5197 8.98769C18.1531 8.57664 17.7095 8.24307 17.2146 8.00625C16.7197 7.76944 16.1833 7.63408 15.6363 7.608C14.279 7.47815 12.9859 8.41958 12.2952 8.41958C11.6044 8.41958 10.48 7.608 9.35558 7.608C8.61133 7.6315 7.88595 7.8504 7.25083 8.24316C6.6157 8.63592 6.09271 9.18899 5.73332 9.84798C4.19125 12.5587 5.33977 16.5354 6.80153 18.7592C7.5324 19.8305 8.40785 21.0397 9.5644 20.9992C10.721 20.9586 11.0904 20.2768 12.4317 20.2768C13.773 20.2768 14.1505 20.9992 15.3231 20.9748C16.4957 20.9505 17.3069 19.8792 18.0458 18.8079C18.4992 18.1339 18.8688 17.4062 19.1461 16.6409C19.179 16.5497 19.1785 16.4496 19.1446 16.3588C19.1107 16.268 19.0457 16.1924 18.9614 16.1459C18.3404 15.8188 17.8202 15.3257 17.4576 14.7203C17.0951 14.1149 16.904 13.4205 16.9053 12.7129Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
